import {useState, useEffect, useContext} from "react"
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import TextractContext from "../../../contexts/TextractContext"


export default ({clients, selectedClient, setSelectedClient}) => {
  const {selectedTextractBill} = useContext(TextractContext)
  useEffect(_ => {
    if (clients[0] && !selectedClient) {
      let utilityIdx = 0
      if (selectedTextractBill && selectedTextractBill.company_id) {
        utilityIdx = clients.findIndex(u => u.id == selectedTextractBill.company_id)
      }
      setSelectedClient(clients[utilityIdx != -1 ? utilityIdx : 0])
    }
  }, [clients])

  useEffect(_ => {
    console.log(clients)
    console.log(selectedClient)
  }, [selectedClient])

  const handleUtilityChange = e => setSelectedClient(e.target.value)


  const handleChange = (event, newValue) => {
    console.log(newValue)
    handleUtilityChange({
      target: {
        value: newValue,
      },
    });
  };

  return (
    <div style={{display: 'flex', justifyContent: 'center'}}>
      <Autocomplete
      id="client-autocomplete"
      options={clients}
      getOptionLabel={(option) => option.name }
      style={{ width: 550, marginBottom: 10}}
      value={selectedClient || null} // Set to null if no utility is selected
      onChange={handleChange}
      renderInput={(params) => (
        <TextField {...params} label="Client" variant="outlined" />
        )}
        getOptionSelected={(option, value) => option.id === value.id}
      />
    </div>
    )
  }